import styled from "styled-components";
export const Header = styled.header `
  background: white;
  border-bottom: 2px solid var(--ant-primary-color);
  padding: 0px;

  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
`;
export const HeaderRow = styled.div `
  line-height: var(--opendash-header-row-height);
  height: var(--opendash-header-row-height);
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
    height: calc(var(--opendash-header-row-height) + 1px);
  }
`;
// export const HeaderDropdown = styled.div<{ right: boolean }>`
//   display: block;
//   padding: 1px;
//   background: #005493;
//   box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
//   top: -6px;
//   position: relative;
//   min-width: 302px;
//   /* margin-left: -10px; */
//   ::before {
//     width: 0;
//     height: 0;
//     border-left: 5px solid transparent;
//     border-right: 5px solid transparent;
//     border-bottom: 5px solid #005493;
//     content: "";
//     position: absolute;
//     top: -5px;
//     left: ${(p) => (p.right ? "auto" : "18px")};
//     right: ${(p) => (p.right ? "18px" : "auto")};
//   }
// `;
// export const HeaderDropdownText = styled.div`
//   padding: 10px;
//   color: #fff;
// `;
// export const HeaderDropdownButton = styled.button`
//   color: #fff;
//   background: #0063ac;
//   display: block;
//   line-height: 40px;
//   min-width: 300px;
//   padding: 0 10px;
//   border: 0;
//   border-bottom: 1px solid #005493;
//   text-align: left;
//   :first {
//     border-top: 1px solid #005493;
//   }
//   :hover {
//     color: #fff;
//     background: #005493;
//   }
//   .anticon {
//     margin-right: 10px;
//   }
// `;
export const Layout = styled.section `
  display: flex;
  flex: auto;
  flex-direction: column;
  background: #f0f2f5;

  width: 100%;
  min-height: 100vh;
  padding-top: var(--opendash-header-height);
`;
export const Content = styled.main `
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: auto;
  min-height: 0;
`;
export const Footer = styled.footer `
  flex: 0 0 auto;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 0px;
`;
export const FooterRowCopyright = styled.div `
  text-align: center;

  height: 40px;
  line-height: 40px;

  > *,
  > a {
    font-size: 12px;
    color: darkgrey;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL19sYXlvdXQvY29tcG9uZW50cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFFdkMsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUE7Ozs7Ozs7Ozs7Q0FVbEMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFBOzs7Ozs7Ozs7Q0FTbEMsQ0FBQztBQUVGLGdFQUFnRTtBQUNoRSxvQkFBb0I7QUFDcEIsa0JBQWtCO0FBQ2xCLHlCQUF5QjtBQUN6QixnREFBZ0Q7QUFDaEQsZUFBZTtBQUNmLHdCQUF3QjtBQUN4QixzQkFBc0I7QUFDdEIsOEJBQThCO0FBRTlCLGVBQWU7QUFDZixnQkFBZ0I7QUFDaEIsaUJBQWlCO0FBQ2pCLDBDQUEwQztBQUMxQywyQ0FBMkM7QUFDM0Msd0NBQXdDO0FBQ3hDLG1CQUFtQjtBQUNuQiwwQkFBMEI7QUFDMUIsaUJBQWlCO0FBQ2pCLG1EQUFtRDtBQUNuRCxvREFBb0Q7QUFDcEQsTUFBTTtBQUNOLEtBQUs7QUFFTCxnREFBZ0Q7QUFDaEQsbUJBQW1CO0FBQ25CLGlCQUFpQjtBQUNqQixLQUFLO0FBRUwscURBQXFEO0FBQ3JELGlCQUFpQjtBQUNqQix5QkFBeUI7QUFDekIsb0JBQW9CO0FBQ3BCLHVCQUF1QjtBQUN2QixzQkFBc0I7QUFDdEIscUJBQXFCO0FBQ3JCLGVBQWU7QUFDZixzQ0FBc0M7QUFDdEMsc0JBQXNCO0FBRXRCLGFBQWE7QUFDYixxQ0FBcUM7QUFDckMsTUFBTTtBQUVOLGFBQWE7QUFDYixtQkFBbUI7QUFDbkIsMkJBQTJCO0FBQzNCLE1BQU07QUFFTixlQUFlO0FBQ2YsMEJBQTBCO0FBQzFCLE1BQU07QUFDTixLQUFLO0FBRUwsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxPQUFPLENBQUE7Ozs7Ozs7OztDQVNuQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUE7Ozs7Ozs7OztDQVNqQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUE7Ozs7Ozs7O0NBUWxDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFBOzs7Ozs7Ozs7OztDQVczQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwic3R5bGVkLWNvbXBvbmVudHNcIjtcblxuZXhwb3J0IGNvbnN0IEhlYWRlciA9IHN0eWxlZC5oZWFkZXJgXG4gIGJhY2tncm91bmQ6IHdoaXRlO1xuICBib3JkZXItYm90dG9tOiAycHggc29saWQgdmFyKC0tYW50LXByaW1hcnktY29sb3IpO1xuICBwYWRkaW5nOiAwcHg7XG5cbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IDBweDtcbiAgbGVmdDogMHB4O1xuICB3aWR0aDogMTAwJTtcbiAgei1pbmRleDogOTk5O1xuYDtcblxuZXhwb3J0IGNvbnN0IEhlYWRlclJvdyA9IHN0eWxlZC5kaXZgXG4gIGxpbmUtaGVpZ2h0OiB2YXIoLS1vcGVuZGFzaC1oZWFkZXItcm93LWhlaWdodCk7XG4gIGhlaWdodDogdmFyKC0tb3BlbmRhc2gtaGVhZGVyLXJvdy1oZWlnaHQpO1xuICB3aWR0aDogMTAwJTtcblxuICAmOm5vdCg6bGFzdC1jaGlsZCkge1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZWVlO1xuICAgIGhlaWdodDogY2FsYyh2YXIoLS1vcGVuZGFzaC1oZWFkZXItcm93LWhlaWdodCkgKyAxcHgpO1xuICB9XG5gO1xuXG4vLyBleHBvcnQgY29uc3QgSGVhZGVyRHJvcGRvd24gPSBzdHlsZWQuZGl2PHsgcmlnaHQ6IGJvb2xlYW4gfT5gXG4vLyAgIGRpc3BsYXk6IGJsb2NrO1xuLy8gICBwYWRkaW5nOiAxcHg7XG4vLyAgIGJhY2tncm91bmQ6ICMwMDU0OTM7XG4vLyAgIGJveC1zaGFkb3c6IDAgMXB4IDJweCAwIHJnYmEoMCwgMCwgMCwgMC41KTtcbi8vICAgdG9wOiAtNnB4O1xuLy8gICBwb3NpdGlvbjogcmVsYXRpdmU7XG4vLyAgIG1pbi13aWR0aDogMzAycHg7XG4vLyAgIC8qIG1hcmdpbi1sZWZ0OiAtMTBweDsgKi9cblxuLy8gICA6OmJlZm9yZSB7XG4vLyAgICAgd2lkdGg6IDA7XG4vLyAgICAgaGVpZ2h0OiAwO1xuLy8gICAgIGJvcmRlci1sZWZ0OiA1cHggc29saWQgdHJhbnNwYXJlbnQ7XG4vLyAgICAgYm9yZGVyLXJpZ2h0OiA1cHggc29saWQgdHJhbnNwYXJlbnQ7XG4vLyAgICAgYm9yZGVyLWJvdHRvbTogNXB4IHNvbGlkICMwMDU0OTM7XG4vLyAgICAgY29udGVudDogXCJcIjtcbi8vICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4vLyAgICAgdG9wOiAtNXB4O1xuLy8gICAgIGxlZnQ6ICR7KHApID0+IChwLnJpZ2h0ID8gXCJhdXRvXCIgOiBcIjE4cHhcIil9O1xuLy8gICAgIHJpZ2h0OiAkeyhwKSA9PiAocC5yaWdodCA/IFwiMThweFwiIDogXCJhdXRvXCIpfTtcbi8vICAgfVxuLy8gYDtcblxuLy8gZXhwb3J0IGNvbnN0IEhlYWRlckRyb3Bkb3duVGV4dCA9IHN0eWxlZC5kaXZgXG4vLyAgIHBhZGRpbmc6IDEwcHg7XG4vLyAgIGNvbG9yOiAjZmZmO1xuLy8gYDtcblxuLy8gZXhwb3J0IGNvbnN0IEhlYWRlckRyb3Bkb3duQnV0dG9uID0gc3R5bGVkLmJ1dHRvbmBcbi8vICAgY29sb3I6ICNmZmY7XG4vLyAgIGJhY2tncm91bmQ6ICMwMDYzYWM7XG4vLyAgIGRpc3BsYXk6IGJsb2NrO1xuLy8gICBsaW5lLWhlaWdodDogNDBweDtcbi8vICAgbWluLXdpZHRoOiAzMDBweDtcbi8vICAgcGFkZGluZzogMCAxMHB4O1xuLy8gICBib3JkZXI6IDA7XG4vLyAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjMDA1NDkzO1xuLy8gICB0ZXh0LWFsaWduOiBsZWZ0O1xuXG4vLyAgIDpmaXJzdCB7XG4vLyAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICMwMDU0OTM7XG4vLyAgIH1cblxuLy8gICA6aG92ZXIge1xuLy8gICAgIGNvbG9yOiAjZmZmO1xuLy8gICAgIGJhY2tncm91bmQ6ICMwMDU0OTM7XG4vLyAgIH1cblxuLy8gICAuYW50aWNvbiB7XG4vLyAgICAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xuLy8gICB9XG4vLyBgO1xuXG5leHBvcnQgY29uc3QgTGF5b3V0ID0gc3R5bGVkLnNlY3Rpb25gXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXg6IGF1dG87XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGJhY2tncm91bmQ6ICNmMGYyZjU7XG5cbiAgd2lkdGg6IDEwMCU7XG4gIG1pbi1oZWlnaHQ6IDEwMHZoO1xuICBwYWRkaW5nLXRvcDogdmFyKC0tb3BlbmRhc2gtaGVhZGVyLWhlaWdodCk7XG5gO1xuXG5leHBvcnQgY29uc3QgQ29udGVudCA9IHN0eWxlZC5tYWluYFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLXNlbGY6IHN0cmV0Y2g7XG4gIGZsZXg6IGF1dG87XG4gIG1pbi1oZWlnaHQ6IDA7XG5gO1xuXG5leHBvcnQgY29uc3QgRm9vdGVyID0gc3R5bGVkLmZvb3RlcmBcbiAgZmxleDogMCAwIGF1dG87XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgbWFyZ2luLWxlZnQ6IGF1dG87XG4gIG1hcmdpbi1yaWdodDogYXV0bztcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMHB4O1xuYDtcblxuZXhwb3J0IGNvbnN0IEZvb3RlclJvd0NvcHlyaWdodCA9IHN0eWxlZC5kaXZgXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcblxuICBoZWlnaHQ6IDQwcHg7XG4gIGxpbmUtaGVpZ2h0OiA0MHB4O1xuXG4gID4gKixcbiAgPiBhIHtcbiAgICBmb250LXNpemU6IDEycHg7XG4gICAgY29sb3I6IGRhcmtncmV5O1xuICB9XG5gO1xuIl19